// jshint esversion: 6
import cookie from 'vue-cookie';

if (!cookie.get('uuid')) {
  cookie.set('uuid', null);
}

if (!localStorage.webshoproles) {
  localStorage.webshoproles = JSON.stringify([]);
}

export default {
  login(vm, authData) {
    return new Promise((resolve) => {
      vm.$webHelper.post('user/login', authData)
        .then((res) => {
          if (res.success) {
            cookie.set('uuid', res.body.uuid, { expires: '8h' });
            localStorage.webshoproles = JSON.stringify(res.body.roles);
          }
          resolve(res);
        })
        .catch(() => {
          resolve(false);
        });
    });
  },

  manualLogin(hash) {
    cookie.set('uuid', hash, { expires: '8h' });
  },
  manualLogout() {
    cookie.set('uuid', null);
  },

  logout(vm, force) {
    return new Promise((resolve) => {
      vm.$webHelper.post('user/logout')
        .then((res) => {
          if (res.success) {
            cookie.set('uuid', null);
            localStorage.webshoproles = JSON.stringify([]);
          }
          resolve(res.success);
        })
        .catch(() => {
          resolve(false);
        });
      if (force) {
        cookie.set('uuid', null);
      }
    });
  },

  // Check if uuid exists
  isLoggedIn() {
    const uuid = cookie.get('uuid') || false;
    return uuid === 'null' ? false : uuid;
  },

  // Check if Admin
  isAdmin() {
    const allRoles = localStorage.webshoproles ? JSON.parse(localStorage.webshoproles) : [];
    return !!allRoles.includes('ROLE_SUN_LOCAL_ADMIN');
  },
};



// WEBPACK FOOTER //
// ./src/auth/index.js